const RequestTypeEnum = {
    1: {
        label: "Proposta",
        color: "#01e600",
        key: "PROPOSE"
    },

    2: {
        label: "Contestação",
        color: "#EB6878",
        key: "NOT_RECOGNIZE_DEBT"
    },
};
export default RequestTypeEnum;
